import type { IMenuItem } from '@/types';
import type { ISectionItem, ISectionItemWithImage, ICollabsItems } from '../types';

export const benefits: ISectionItemWithImage[] = [
  {
    id: 'pickup',
    title: 'LANDING.BENEFITS.ONE_TITLE',
    content: 'LANDING.BENEFITS.ONE_CONTENT',
    image: '/images/benefits/one.webp',
    srcSet: '/images/benefits/one@2x.webp 2x, /images/benefits/one@3x.webp 3x',
  },
  {
    id: 'shipping',
    title: 'LANDING.BENEFITS.TWO_TITLE',
    content: 'LANDING.BENEFITS.TWO_CONTENT',
    image: '/images/benefits/two.webp',
    srcSet: '/images/benefits/two@2x.webp 2x, /images/benefits/two@3x.webp 3x',
  },
  {
    id: 'damage-coverage',
    title: 'LANDING.BENEFITS.THREE_TITLE',
    content: 'LANDING.BENEFITS.THREE_CONTENT',
    image: '/images/benefits/three.webp',
    srcSet: '/images/benefits/three@2x.webp 2x, /images/benefits/three@3x.webp 3x',
  },
];

export const faqs: ISectionItem[] = [
  {
    id: 'faq-one',
    title: 'LANDING.FAQ.ONE_TITLE',
    content: 'LANDING.FAQ.ONE_CONTENT',
  },
  {
    id: 'faq-two',
    title: 'LANDING.FAQ.TWO_TITLE',
    content: 'LANDING.FAQ.TWO_CONTENT',
  },
  {
    id: 'faq-three',
    title: 'LANDING.FAQ.THREE_TITLE',
    content: 'LANDING.FAQ.THREE_CONTENT',
  },
  {
    id: 'faq-four',
    title: 'LANDING.FAQ.FOUR_TITLE',
    content: 'LANDING.FAQ.FOUR_CONTENT',
  },
];

export const packaging: Omit<ISectionItemWithImage, 'content'>[] = [
  {
    title: 'LANDING.PACKAGING.P_ONE',
    image: '/images/packaging/poster.webp',
    srcSet: '/images/packaging/poster@2x.webp 2x, /images/packaging/poster@3x.webp 3x',
    id: 'p-one',
  },
  {
    title: 'LANDING.PACKAGING.P_TWO',
    image: '/images/packaging/oggetti-deco.webp',
    srcSet: '/images/packaging/oggetti-deco@2x.webp 2x, /images/packaging/oggetti-deco@3x.webp 3x',
    id: 'p-two',
  },
  {
    title: 'LANDING.PACKAGING.P_THREE',
    image: '/images/packaging/complementi.webp',
    srcSet: '/images/packaging/complementi@2x.webp 2x, /images/packaging/complementi@3x.webp 3x',
    id: 'p-three',
  },
  {
    title: 'LANDING.PACKAGING.P_FOUR',
    image: '/images/packaging/strumenti.webp',
    srcSet: '/images/packaging/strumenti@2x.webp 2x, /images/packaging/strumenti@3x.webp 3x',
    id: 'p-four',
  },
  {
    title: 'LANDING.PACKAGING.P_FIVE',
    image: '/images/packaging/sculture.webp',
    srcSet: '/images/packaging/sculture@2x.webp 2x, /images/packaging/sculture@3x.webp 3x',
    id: 'p-five',
  },
  {
    title: 'LANDING.PACKAGING.P_SIX',
    image: '/images/packaging/gioielli.webp',
    srcSet: '/images/packaging/gioielli@2x.webp 2x, /images/packaging/gioielli@3x.webp 3x',
    id: 'p-six',
  },
  {
    title: 'LANDING.PACKAGING.P_SEVEN',
    image: '/images/packaging/abbigliamento.webp',
    srcSet:
      '/images/packaging/abbigliamento@2x.webp 2x, /images/packaging/abbigliamento@3x.webp 3x',
    id: 'p-seven',
  },
  {
    title: 'LANDING.PACKAGING.P_EIGHT',
    image: '/images/packaging/manoscritti.webp',
    srcSet: '/images/packaging/manoscritti@2x.webp 2x, /images/packaging/manoscritti@3x.webp 3x',
    id: 'p-eight',
  },
];

export const steps: ISectionItemWithImage[] = [
  {
    id: 'step-1',
    title: 'LANDING.STEPS.ONE_TITLE',
    content: 'LANDING.STEPS.ONE_CONTENT',
    image: '/images/steps/one.webp',
    srcSet: '/images/steps/one@2x.webp 2x, /images/steps/one@3x.webp 3x',
  },
  {
    id: 'step-2',
    title: 'LANDING.STEPS.TWO_TITLE',
    content: 'LANDING.STEPS.TWO_CONTENT',
    image: '/images/steps/two.webp',
    srcSet: '/images/steps/two@2x.webp 2x, /images/steps/two@3x.webp 3x',
  },
  {
    id: 'step-3',
    title: 'LANDING.STEPS.THREE_TITLE',
    content: 'LANDING.STEPS.THREE_CONTENT',
    image: '/images/steps/three.webp',
    srcSet: '/images/steps/three@2x.webp 2x, /images/steps/three@3x.webp 3x',
  },
];

export const menuItems: IMenuItem[] = [
  {
    id: 'benefits',
    href: '#benefits',
    label: 'LANDING.MENU.BENEFITS',
  },
  {
    id: 'how-it-works',
    href: '#how-it-works',
    label: 'LANDING.MENU.HOWITWORKS',
  },
  {
    id: 'packaging',
    href: '#packaging',
    label: 'LANDING.MENU.PACKAGING',
  },
];

export const collabItems: ICollabsItems[] = [
  {
    id: 'collab-one',
    image: '/images/collabs/logo_unfair_default@1x.svg',
    imageHover: '/images/collabs/logo_unfair_hover@1x.svg',
    url: 'https://www.un-fair.com/',
  },
  {
    id: 'collab-two',
    image: '/images/collabs/logo_raja_default@1x.svg',
    imageHover: '/images/collabs/logo_raja_hover@1x.svg',
    url: 'https://www.rajapack.it/',
  },
  {
    id: 'collab-three',
    image: '/images/collabs/logo_artaporter_default@1x.svg',
    imageHover: '/images/collabs/logo_artaporter_hover@1x.svg',
    url: 'https://artaporter.it/',
  },
];
